<template>
	<validation-provider
			:name="'AdminSwitch-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			mode="lazy"
			v-slot="{ errors }">
		<v-switch
				class="switch_"
				v-model="$store.state.admin.input[inputItemKey]"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSwitch',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		}
	}
</script>

<style scoped>
	.switch_ {
		padding-top: 20px;
		margin-top: 0;
	}
</style>
